export default __webpack_public_path__ + "static/media/1909.7d57acae.png";